import { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./user-chat.css";
import { Switch } from "@mui/material";
import ChatList from "./ChartList";
import ChatWindow from "./ChatWindow";
import ChatDetails from "./ChatDetails";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";


const UserChat = () => {
  const ApiBaseURL = process.env.REACT_APP_GROUP_URL;
  const token = localStorage.getItem("authToken");
  const isAgent = localStorage.getItem("isAgent") === "true";
  const [activeChat, setActiveChat] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showUnread, setShowUnread] = useState(false);
  const [activeChats, setActiveChats] = useState([]);
  const [smallScreen, setSmallScreen] = useState(false);
  const [ShowSendingDiv, setShowSendingDiv] = useState(true);
  const messageRefs = useRef({});
  const [conversationHistory, setConversationHistory] = useState([]);
  const [isSidepanelOpen, setIsSidepanelOpen] = useState(false);
  const [FilterFlagId, setFilterFlagId] = useState("");
  const [IsAgentToAgent, setIsAgentToAgent] = useState(false);
  const previousChatsRef = useRef([]);
  const navigate = useNavigate();

  const toggleSidePanel = () => setIsSidepanelOpen(!isSidepanelOpen);

  // Scroll to date
  const handleDateSelect = (date) => {
    if (messageRefs.current[date]) {
      messageRefs.current[date].scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (window.innerWidth <= 576) {
      setSmallScreen(true);
    }
  }, []);

  const user = sessionStorage.getItem("user");
  useEffect(() => {
    if (!user || user === "null") {
      navigate('/group/login', { replace: true });
    }
  }, [user]);

  const fetchActiveChats = async () => {
    try {
      const response = await axios.get(
        `${ApiBaseURL}WhatsappGroup/GetLoadChatBox?FlagID=${FilterFlagId}&isAgent=${isAgent}`,
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      );

      const groupedChats = {};

      response.data.forEach((chat) => {
        // Group ke liye GroupId use hoga, normal chat ke liye mobile
        const key = chat.FromMob;

        const contactName = chat.GroupId
          ? chat.GroupName
          : chat.Contact
            ? chat.Contact.split(" ")[0]
            : "Unknown";

        if (!groupedChats[key]) {
          groupedChats[key] = {
            id: chat.GroupId ? chat.GroupId : chat.Sno,
            name: contactName,
            number: chat.FromMob,
            groupId: chat.GroupId,
            groupName: chat.GroupName,
            members: [],
            messages: [
              {
                text: chat.Messagetext,
                from: "other",
                time: chat.Insertdatetime,
              },
            ],
            unread: parseInt(chat.MsgCount || 0, 10),
            lastMessageTime: new Date(chat.Insertdatetime),
            flags: chat.Flags,
            MarkUnread: chat.HasDiff,
          };
        }

        // Group members add karo
        groupedChats[key].members.push(chat.fromMob);

        if (
          new Date(chat.insertdatetime) >
          groupedChats[key].lastMessageTime
        ) {
          groupedChats[key].lastMessageTime = new Date(chat.insertdatetime);

          groupedChats[key].messages = [
            {
              text: chat.messagetext,
              from: "other",
              time: chat.insertdatetime,
            },
          ];
        }

        // Unread count add karo
        groupedChats[key].unread += parseInt(chat.msgCount || 0, 10);
      });

      const chats = Object.values(groupedChats);

      chats.sort(
        (a, b) => new Date(b.lastMessageTime) - new Date(a.lastMessageTime)
      );

      if (
        JSON.stringify(chats) !==
        JSON.stringify(previousChatsRef.current)
      ) {
        setActiveChats(chats);
        previousChatsRef.current = chats;
      }
    } catch (error) {
      console.error("Error fetching active chat data:", error);
    }
  };

  useEffect(() => {
    // Initial fetch for active chats
    fetchActiveChats();

    // Set up interval to fetch active chat data every 2 seconds
    const intervalId = setInterval(fetchActiveChats, 2000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [ApiBaseURL, token, FilterFlagId]);

  const filteredChats = activeChats
    .filter(
      (chat) =>
        chat.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        chat.number.includes(searchTerm)
    )
    .filter((chat) => !showUnread || chat.unread > 0 || chat.MarkUnread > 0);

  return (
    <>
      {/* top nav  */}
      <Navbar nav={[{
        title: 'User Chat',
        link: 'userchat'
      }, { title: 'Group List', link: 'grouplist' }
      ]} />
      <div className="flex min-h-[calc(100vh_-_104px)]">
        {!activeChat && smallScreen && (
          <div className="chat-list w-full lg:w-1/3 md:w-1/2 sm:w-2/3 bg-white rounded overflow-hidden">
            {/* <div className="flex justify-end mx-1 px-4 mt-1 pt-1 mb-0 pb-0">
              <Switch />
            </div> */}

            <ChatList
              chats={filteredChats}
              setActiveChat={setActiveChat}
              setSearchTerm={setSearchTerm}
              setShowUnread={setShowUnread}
              setShowSendingDiv={setShowSendingDiv}
              setIsAgentToAgent={setIsAgentToAgent}
              IsAgentToAgent={IsAgentToAgent}
              searchTerm={searchTerm}
            />
          </div>
        )}
        {!smallScreen && (
          <div className="chat-list lg:w-1/3 md:w-1/2 sm:w-2/3 bg-white rounded overflow-hidden">
            <div className="flex justify-between mx-1 px-4 mt-1 pt-1 mb-0 pb-0">
              {isAgent && (
                <div className="text-lg font-bold">
                  Away <Switch />
                </div>
              )}
            </div>
            <ChatList
              chats={filteredChats}
              setActiveChat={setActiveChat}
              activeChat={activeChat}
              setSearchTerm={setSearchTerm}
              setShowUnread={setShowUnread}
              setShowSendingDiv={setShowSendingDiv}
              setFilterFlagId={setFilterFlagId}
              FilterFlagId={FilterFlagId}
              setIsAgentToAgent={setIsAgentToAgent}
              IsAgentToAgent={IsAgentToAgent}
              searchTerm={searchTerm}
            />
          </div>
        )}
        {activeChat && (
          <ChatWindow
            chat={activeChat}
            setActiveChat={setActiveChat}
            smallScreen={smallScreen}
            ShowSendingDiv={ShowSendingDiv}
            setConversationHistory={setConversationHistory}
            messageRefs={messageRefs}
            handleDateSelect={handleDateSelect}
            toggleSidePanel={toggleSidePanel}
            isSidepanelOpen={isSidepanelOpen}
            setIsAgentToAgent={setIsAgentToAgent}
            IsAgentToAgent={IsAgentToAgent}
          />
        )}
        {activeChat && (
          <ChatDetails
            chat={activeChat}
            isSidepanelOpen={isSidepanelOpen}
            toggleSidePanel={toggleSidePanel}
            conversationHistory={conversationHistory}
            onDateSelect={handleDateSelect}
            setIsAgentToAgent={setIsAgentToAgent}
            IsAgentToAgent={IsAgentToAgent}
          />
        )}
      </div>
      <div className="w-full bg-[#2c678d] font-semibold shadow-lg flex justify-center items-center py-3 px-4">
        © 2026 My Inbox Media®. All rights reserved. Since 2010.
      </div>
    </>
  );
};

export default UserChat;